import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { InfoOption } from '../../components/info/info.component';
import { infoOption } from '../../services/ref';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'subscribe-in-life',
    templateUrl: './subscribe-in-life.component.html',
    styleUrls: ['./subscribe-in-life.component.scss'],
    standalone: false
})
export class SubscribeInLifeComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = infoOption;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
